import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IFFConfig } from '../types/config';

export default ((state = {
  enabled: false,
  mapping: {
  }
}, action: ActionObject): IFFConfig => {
  switch (action.type) {
    case ActionTypes.CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<IFFConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/fusionfabric/reducers/config.ts